import React, { useEffect, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import Auth from "../../utils/AuthUtils";
import userAPI from "../../api/UserApi";
import { getTimeAgo } from "../../helper/Helper";

function Dashboard() {
  const userDetails = Auth.getUser();
  const [orders, setOrders] = useState([]);

  useEffect(() => {
    fetchLatestOrder();
  }, []);

  const fetchLatestOrder = async () => {
    try {
      const res = await userAPI.fetchLatestOrder();
      if (res.code === 200) {
        const result = res.data;

        setOrders(result);
      }
    } catch (err) {}
  };

  return (
    <>
      <div className="main-content-account mb-5 rounded-3">
        <div className="my-acount-content account-dashboard">
          <div className="box-account-title">
            <p className="hello-name display-sm fw-medium">
              Hello {userDetails?.firstName}!
            </p>
            <p className="notice text-sm">
              Today is a great day to check your account page. You can check{" "}
              <NavLink
                to="/users/orders"
                className="text-muted text-decoration-underline"
              >
                your last orders
              </NavLink>
              . Or maybe you can start to shop{" "}
              <NavLink
                to="/shop"
                className="text-muted text-decoration-underline"
              >
                out latest products
              </NavLink>
            </p>
          </div>
          <div className="content-account">
            <ul className="box-check-list flex-sm-nowrap">
              <div className="row">
                {orders ? (
                  <div className="col-md-4">
                    <div className="order-card" key={orders._id}>
                      <div className="order-header">Order #{orders.orderId}</div>
                      <div className="order-meta">
                        <div>
                          <b>Date:</b> {getTimeAgo(orders?.createdAt)}
                        </div>
                        <div>
                          <b>Amount:</b> ₹{orders?.total}/-
                        </div>
                      </div>
                      <div className="order-status">
                        {orders?.status}
                      </div>
                    </div>
                  </div>
                ) : (
                  <li>
                    <Link to="/users/orders" className="box-check text-center text-decoration-none">
                      <div className="text">
                        <div className=" name-type text-xl fw-bold text-dark" >
                          Orders
                        </div>
                        <p className="sub-type text-sm">
                          Check the history of all your orders
                        </p>
                      </div>
                    </Link>
                  </li>
                )}
              </div>
            </ul>
          </div>
        </div>
      </div>
    </>
  );
}

export default Dashboard;
